import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import PageHeader from '../../components/PageHeader';
import RequestHandler from './RequestHandler';
import configurationService from '../../services/ConfigurationsServices';
import { useAuth } from '../../contexts/AuthContext';
import { toast, ToastContainer } from 'react-toastify';

const GeneralSettings = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const { user } = useAuth();

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const onSubmit = async (data) => {
        const logoPath = image ? `www.wroffy_crm.com/${image.name}` : '';
        const requestBody = RequestHandler(data, "General Settings", "configurations", logoPath, true, user);

        try {
            const response = await configurationService.createConfiguration(requestBody);

            if (response?.data?.status) {
                toast.success(response?.data?.message);
                reset();
                setImage(null);
                setImagePreview(null);
            }
        } catch (error) {
            const errorsData = error?.response?.data?.data ?? {};
            const validationErrors = errorsData?.errors ?? [];
            validationErrors.forEach((err) => {
                console.error(`${err.field}: ${err.message}`);
                toast.error(`${err.field}: ${err.message}`);
            });
            
            if (!validationErrors.length) {
                console.error('Failed to submit data:', error);
                toast.error('Failed to submit data');
            }
        }
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-12">
                            <PageHeader title="General Settings" />
                            <div className="card p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Company Logo</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    onChange={handleImageChange}
                                                    accept="image/*"
                                                />
                                                <hr />
                                            </div>
                                            {imagePreview && (
                                                <div className="form-group">
                                                    <img
                                                        src={imagePreview}
                                                        alt="Preview"
                                                        style={{ width: '200px', height: 'auto' }}
                                                    />
                                                </div>
                                            )}
                                            <div className="form-group">
                                                <label className="form-label">Company Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...register('companyName', { required: 'Company is required' })}
                                                />
                                                {errors.companyName && (
                                                    <div className="text-danger">{errors.companyName?.message}</div>
                                                )}
                                                <hr />
                                            </div>
                                            <div className="form-group">
                                                <label className="form-label">Company Main Domain</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...register('companyDomain', { required: 'Company domain is required' })}
                                                />
                                                {errors.companyDomain && (
                                                    <div className="text-danger">{errors.companyDomain?.message}</div>
                                                )}
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Save
                                        </button>
                                    </div>
                                </form>
                                <hr className="my-5" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default GeneralSettings;
